import * as Yup from "yup";

export const insuranceCoverageValidationSchema = Yup.object().shape({
  coverageType: Yup.mixed().required("Coverage type is required"),
  minimumCoverageAmount: Yup.number()
    .positive("Minimum coverage amount must be positive")
    .nullable(),
  instructions: Yup.string()
    .max(1000, "Instructions cannot exceed 1000 characters")
    .nullable()
});
